
const zh = {
	common: {
		'productIntroduction': '产品介绍',
		'cardPayment': '卡支付',
		'subscriptionPayments': '订阅支付',
		'linkPayments': '链接支付',
		'bnpl': '先买后付',
		'dcc': '动态货币转换',
		'checkoutDemo': '收银台演示',
		'solutions': '解决方案',
		'gamingSolutions': '游戏解决方案',
		'E-commerceSolutions': '电商解决方案',
		'resources': '资源',
		'support': '支持',
		'integration': '接入指南',
		'api': 'API文档',
		'FAQ': '常见问题',
		'paymentMethods': '支付方式',
		'login': '登录',
		'contactUs': '联系我们',
		'about': '关于',
		'aboutUs': '关于我们',
		'newsCenter': '资讯中心',
		'privacyPolicy': '隐私政策',
		'emailSupport': '邮件帮助',
		'cookie': 'Cookie政策',
		'socialMedia': '社交媒体',
		register: '立即注册',
		copy: '© 2015-2025 checkout.pingpongx.com. 杭州乒乓智能技术有限公司 All Rights Reserved.浙ICP备15025700号-1. 经营许可证:合字B2-20200174 浙公网安备 33010802003226号',
		customerSupport: '客服咨询'

	},
	index: {
		title: 'PingPong 全球收单',
		slogan1: '支付无界',
		slogan2: '让企业全球化更自由',
		desc1: '直连全球六大卡组',
		desc2: '支持本地银行及支付机构',
		data1: '业务覆盖国家及地区',
		data2: '交易覆盖币种',
		data3: '已获得全球牌照和许可',
		data4: '累计交易资金（亿元）',
		based: '*数据统计更新至2024年底',

		register: '立即注册',
		contactUs: '联系我们',
		globalText: '全球合作伙伴',
		payMethods: {
			title: '满足全球消费者首选的支付方式',
			content: '轻松接入',
			number: '200+',
			content1: '全球支付方式，',
			content2: '提升用户转化率',
			label: '本地最受欢迎的支付方式',
			more: '查看支付方式'
		},
		solution: {
			slogan1: '丰富的支付方案',
			slogan2: '打造更佳用户支付体验',
			paynow: '即时支付',
			paynowDesc1: '一键直达，六大卡组覆盖全球',
			paynowDesc2: '无卡支付进一步提升订单转化率',
			more: '了解详情',
			bnpl: '先买后付',
			bnplDesc1: '先享未来，后付无忧',
			bnplDesc2: '支持不同期灵活选择',
			subscription: '订阅支付',
			subscriptionDesc1: '订阅用户轻松绑卡',
			subscriptionDesc2: ' 随时调整付费周期'
		},
		guard: {
			title: '全维守护商业动脉',
			intelligent: '智能支付',
			intelligentSubTitle: '动态优化成功率 提高用户转化',
			intelligentDesc1: '实时解析支付环境多维参数',
			intelligentDesc2: '自动规避通道拥堵与风险节点',
			security: '系统安全',
			securitySubTitle: '全链路金融安全',
			based: '*基于PingPong技术系统统计来源',
			securityDesc1: 'PCI DSS+SOC2双认证保障',
			securityDesc2: '99.99%的系统稳定性*',
			risk: '风险防范',
			riskSubTitle: '风险熔断 智能防护',
			riskDesc1: '构建多层实时风控防护网络',
			riskDesc2: '精准识别非常态交易行为特征',
			services: '专业服务',
			servicesSubTitle: '全天守护 专家响应',
			servicesDesc1: '支付异常多级保障机制',
			servicesDesc2: '全场景解决方案经验'
		},
		mode: {
			title: '三种集成模式',
			title1: '助您快速启动在线支付',
			document: '查看文档',
			hosted: '托管式',
			hostedDesc: '无需开发快速上线收款系统',
			hostedDesc1: '主流支付方式自动聚合',
			embedded: '内嵌式',
			embeddedDesc: '内嵌式组建理想支付界面',
			embeddedDesc1: '提升用户支付体验',
			api: 'API',
			apiDesc: '定制全流程支付处理逻辑',
			apiDesc1: '满足复杂业务场景需求'
		},
		blog: {
			title: '全球收单动态相关新闻',
			desc: '获取行业洞察，了解最新支付技术，',
			desc1: '助力您拓展新兴市场，全面提升业务竞争力。',
			more: '查看更多'
		},
		faq: {
			title: '常见问题',
			more: '查看更多常见问题'
		},
		contactTitle: '即刻开启全球收单'
	},
	cardPayment: {
		title: '卡支付',
		desc1: '直连六大卡组',
		desc2: '覆盖全球用户',
		content: '支持国际6大卡组；覆盖全球主要本地卡组',
		content2: '',
		support: '支持多场景支付',
		increase: '增加企业收入',
		eCommerce: '跨境电商',
		eCommerceDesc: '一键全球收款',
		eCommerceDesc1: '助商家无障碍拓展国际市场',
		game: '游戏充值',
		gameDesc: '支持多种游戏付费场景',
		gameDesc1: '助游戏商家降本增效',
		ota: '教育/AI等',
		otaDesc: '适用更多行业和支付需求',
		cardDesc1: '一卡通行，即输即收，',
		cardDesc2: '跨境无忧',
		concactTitle: '快速解锁卡支付，助力业务增长'

	},
	subscriptionPayment: {
		title: '订阅支付',
		desc1: '智能循环订阅',
		desc2: '让收入更稳定',
		content1: '失败自动重试，减少用户流失',
		content2: '组合订阅（周/月/年付）统一管理，灵活调整',
		support: '灵活匹配多种销售模式',
		stream: '流媒体订阅',
		streamDesc1: '实时监控卡片有效期变化',
		streamDesc2: '系统自动更新新卡信息',
		membership: '会员充值',
		membershipDesc1: '自动续费省心，无需重复下单',
		membershipDesc2: '灵活管理支出，随时可暂停或取消',
		saas: 'SaaS服务',
		saasDesc: '可视化订阅组合配置',
		saasDesc1: '智能周期计费',
		step: {
			title: '从单次购买到长期订阅',
			one: {
				title: '灵活选择订阅套餐',
				desc: '将单次服务升级为周/月/年套餐，匹配用户不同消费习惯。'
			},
			two: {
				title: '自动签约，绑定即留存',
				desc: '用户支付时自动完成代扣签约，无需重复操作。'
			},
			three: {
				title: '自动续费无忧管理',
				desc: '首次扣款成功后，系统按周期自动执行续费，异常支付实时预警。'
			}

		},
		concactTitle: '快速解锁订阅模式，助力业务增长'

	},
	bnplPayment: {
		title: '先买后付',
		desc1: '接入先买后付支付服务',
		desc2: '分期方案提升营收',
		content: '直连全球领先BNPL品牌，降低消费门槛，提高订单转化',
		salesGrowth: {
			title: '降低消费价格门槛',
			title1: '有效增加交易金额',
			customerPrice: {
				title: '客单价',
				desc: '平均提升15%*'
			},
			orderConversion: {
				title: '高价值订单转化率',
				desc: '平均提升10%*'
			},
			industryPreference: {
				title: '有效定位行业偏好',
				desc: '3C，美妆，服装，家居品必选'
			},
			based: '*基于PingPong内部客户统计来源'

		},
		step: {
			title: '三步完成支付',
			title1: '先买后付0等待',
			one: {
				title: '选择分期方案',
				desc: '灵活选择BNPL和分期等多种支付方案。'
			},
			two: {
				title: '一键授权额度审批',
				desc: '绑定/登录先买后付账户，完成实时信用评估。'
			},
			three: {
				title: '完成收款',
				desc: '用户确认成交，商户实时到账全款。'
			}

		},
		concactTitle: '快速解锁先买后付，助力业务增长'

	},
	linkPayment: {
		title: '订阅支付',
		desc1: '轻松创建链接',
		desc2: '全球支付高效安全',
		content1: '无需开发｜极速级创建｜全球客户一键触达',
		content2: '支持多国支付方式｜社群/线下场景无缝收款',
		support: '多场景可用 ',
		support1: '一键生成即刻收款',
		customer: '客服对话',
		customerDesc1: '在线客服实时推送支付页',
		customerDesc2: '付款即时到账',
		media: '社交媒体',
		mediaDesc1: '社媒平台一键分享',
		mediaDesc2: '粉丝无需跳转即可完成支付',
		email: '电子邮件和短信',
		emailDesc: '支付邮件模板',
		emailDesc1: '一键发送提升支付转化率',
		step: {
			title: '无需代码，全渠道收款，',
			title1: '生意轻松扩展',
			one: {
				title: '创建支付链接',
				desc: '简单三步，即可创建专业收款链接和品牌二维码，支持一次性交易或长期重复使用，满足不同业务需求。'
			},
			two: {
				title: '分享支付链接',
				desc: '收款链接或二维码可通过电子邮件、社交媒体、短信等方式分享，还可嵌入到带有品牌标志的账单中。'
			},
			three: {
				title: '完成收款',
				desc: '实时掌控收款状态：后台直观展示交易进展，即时收到付款通知，轻松管理现金流，助力业务稳健增长。'
			}

		},
		concactTitle: '快速解锁链接支付，助力业务增长'

	},
	dcc: {
		desc1: '支持动态货币转化',
		desc2: '价格更透明，支付更安心',
		content: '支持80+币种收银台自动转换，快速实现消费者本币支付；公开透明的外汇价格，实现全球价格统一管理。',
		support: '轻松实现本币计价 ',
		support1: '有效提升支付体验',
		habit: '符合消费习惯',
		habitDesc1: '本币计价更符合海外消费者消费习惯',
		time: '缩短决策时间',
		timeDesc1: '本币计价不需要消费者手动计算商品价值',
		timeDesc2: '缩短购买决策时间',
		rate: '提升订单转化率',
		rateDesc: '本币计价比外币计价',
		rateDesc1: '平均提升高达5%的订单转化率*',
		based: '*基于PingPong内部客户统计来源',
		step: {
			title: 'DCC让企业',
			title1: '轻松实现订单汇率管理',
			one: {
				title: '支持下单锁汇，满足不同时长的锁汇要求',
				desc: '满足不同企业对订单汇率的锁定时效，有效延长消费者交易意向。'
			},
			two: {
				title: '双币智选，适配多类跨境支付场景',
				desc: '支持根据卡BIN自动识别本币币种，DCC支持消费者自主选择本币或者外币交易。'
			},
			three: {
				title: '汇率透明，有效帮助企业管理汇率风险',
				desc: '企业在交易之前可以提前获得换汇价格，可以提前评估换汇成本，有效管理外汇风险。'
			}

		},
		concactTitle: '快速解锁动态货币转换服务，助力业务增长'
	},
	eCommerce: {
		introduce: {
			desc: '全球电商支付解决方案',
			desc1: '支持企业多样化交易场景',
			content: '支持自建独立站、多SAAS建站系统、开源建站系统等'
		},
		experience: {
			title1: '优化结账体验',
			title2: '提升用户转化',
			one: {
				title: '全球销售',
				desc: '收银台自动匹配全球买家的语言和设备，支持多种国际支付方式，打造流畅的结账体验，有效减少订单流失率。'
			},
			two: {
				title: '灵活风格',
				desc: '支持收银台个性化定制，实现收银台与品牌的风格统一。'
			}
		},
		methods: {
			title1: '多种支付方案',
			title2: '保障订单转化',
			one: {
				title: '灵活的信用卡产品',
				desc: '支持信用卡一次性扣费，绑卡支付，分期付款等支付方案，满足客户消费偏好。'
			},
			two: {
				title: '多样的本地化支付方案',
				desc: '根据不同国家线上支付市场份额，为消费者匹配多样的本地支付方式，贴近各国消费习惯。'
			},
			three: {
				title: '支持多种BNPL信用产品',
				desc: '根据BNPL品牌市场排名，支持消费者使用安全可靠的BNPL产品，降低消费门槛。'
			}
		},
		currency: {
			title1: '支持多币种结算',
			title2: '轻松实现人民币入境',
			desc: '持有境内境外支付牌照，支持美金、欧元、日元、人民币等主流币种结算'
		},
		concactTitle: '立刻了解电商收单方案'
	},
	gaming: {
		introduce: {
			desc: '支持全球游戏发行者',
			desc1: '多场景支付方案'
		},
		scene: {
			one: {
				title: '全设备适配',
				desc: '支持PC、平板、手机等多种设备'
			},
			two: {
				title: '灵活的扣费模式',
				desc: '支持游戏道具、会员订阅等',
				desc1: '不同付费产品'
			},
			three: {
				title: '营销策略',
				desc: '支持游戏多种活动营销方案',
				desc1: '提高游戏营收'
			}
		},
		payType: {
			title1: '支持多种支付类型',
			title2: '满足不同画像消费者对支付方式的偏好',
			card: {
				title: '信用卡支付',
				desc: '支持全球六大卡组，快速覆盖全球消费者'
			},
			mobile: {
				title: '移动支付/电子钱包支付',
				desc: '支持Apple Pay、Google Pay和各国主流电子钱包，满足游戏消费主力支付需求'
			},
			prepaid: {
				title: '预付卡支付',
				desc: '支持PaysafeCard等预付卡类的支付方式，满足无卡人士的游戏消费需求'
			},
			carrier: {
				title: '运营商支付',
				desc: '满足游戏运营商支付的支付诉求，最大程度实现联“网”可支付'
			}
		},
		marketing: {
			title: '支持多种形式的游戏营销活动',
			desc: '实现营收高达20%以上的增长*',
			discount: '游戏商品配置折扣',
			payDiscount: '支付环节的随机满减',
			orderDiscount: '订单的满减活动',
			appDiscount: '境外支付APP等流量曝光',
			based: '*基于PingPong内部客户统计来源'
		},
		concactTitle: '立刻了解游戏收单方案'
	},
	contactUs: {
		globalization: '助力企业全球化',
		solutions: '提供优质全球支付解决方案',
		name: '姓名',
		nameRule: '此栏为必填项。 输入一个在2-30个字符之间的有效名称，并带有字母字符。',
		email: '工作邮箱',
		emailRule: '此栏为必填项。 输入一个有效的电子邮件地址 example@domain.com',
		phone: '电话',
		phoneRule: '此栏为必填项。请输入正确的手机号码',
		company: '公司名称',
		companyRule: '此栏为必填项。 输入一个介于2-30个字母数字字符之间的有效名称。',
		link: '公司网站/产品链接',
		linkRule: '此栏为必填项。 输入一个有效的网址（例如 https://www.pingpongx.com）。',
		agreement1: '我同意PingPong依据',
		agreement2: '隐私政策',
		agreement3: '处理我的信息，上述信息仅用于授权PingPong向我发送产品、活动信息。',
		sales: '联系销售',
		submitSuccess: '提交成功',
		thank: '感谢您的提交，我们将尽快与您联系。',
		close: '关闭'
	},
	cookiePolicy: {
		title: 'PingPong Cookie 政策',
		date: '最新更新时间：2025年5月',
		desc1: '感谢您选择 PingPong（定义见我们的<a href=https://www.pingpongx.com/zh/termsandConditions?channel=bing&inviteCode=ac-18&utm_source=bing-PC&utm_medium=pin-pai-ci-PC&utm_campaign=he-xin-ci&utm_term=pingpong&msclkid=1b12a230bf3b1f5f9a5cca1bb547799a&cb=true target=_blank>《PingPong服务条款及条件》</a>）。我们致力于保护您的个人信息和隐私权，并高度重视您的隐私。本 Cookie 政策中的 “您” 指访问我们任何网站或应用程序（单称 “站点”，合称 “站点”）的用户或访客。',
		desc2: '本政策描述了我们的站点使用哪些 Cookie 及其他类似（如跟踪）技术（如像素或 SDK，统称 “Cookie”），以及如何使用这些技术。Cookie 可能收集个人信息，因此我们建议您阅读我们的《隐私政策》，以进一步了解我们如何使用、存储和保护您的个人信息安全。',
		section1: {
			title: '什么是 Cookie？',
			desc: 'Cookie 是一种简单的文本文件，在您访问我们的站点时存储在您的计算机或其他设备（如手机）上。这使我们的站点能够识别您的设备，区别于其他用户的设备。',
			desc1: 'Cookie 可分为 “第一方” Cookie 和 “第三方” Cookie，我们的站点会同时使用这两种类型的 Cookie。第一方 Cookie：由我们在站点上设置，仅我们的站点可读取。第三方 Cookie：由提供广告和分析等服务的第三方设置。这些第三方可能会收集您的设备 ID、IP 地址或其他使用站点的信息，作为其向我们提供分析的一部分。如需了解第三方如何收集和使用您的数据，请访问：',
			google: '<a href="https://policies.google.cn/technologies/partner-sites?hl=en" target="_blank">https://policies.google.cn/technologies/partner-sites?hl=en</a>'
		},
		section2: {
			title: '使用 Cookie 需要您的同意吗？',
			desc: '除某些特殊情况外（如 Cookie 对通信传输必不可少，或严格必要用于提供您请求的服务），我们将在放置 Cookie 前征得您的同意。',
			desc1: '您可以随时通过页面底部的 “隐私偏好中心” 撤回对 Cookie 使用的同意或调整 Cookie 偏好。请注意，您可能需要刷新页面才能使设置生效。'
		},
		section3: {
			title: '我们使用哪些类型的 Cookie？',
			desc: '每次访问我们的站点时，系统会提示您接受或拒绝 Cookie。其目的是使站点能够记住您的偏好（如用户名、语言等）一段时间，避免您在同一访问期间重复输入。',
			desc1: 'Cookie 按常规类型分类如下：',
			table: {
				column: {
					title1: 'Cookie 类型',
					title2: '用途'
				},
				data: [{
					type: '必需型',
					purpose: '这类 Cookie 是我们提供和运行站点所严格必需的，用户无法停用或拒绝，否则会影响站点的正常功能和使用。没有这些 Cookie，您将无法在页面间导航或使用站点的某些核心功能。'
				},
				{
					type: '功能型',
					purpose: '使我们能够根据您的选择运行站点。例如，功能型 Cookie 会记住您的设置（如语言偏好）。'
				},
				{
					type: '分析型',
					purpose: '使我们和第三方服务能够收集汇总数据，用于统计访客如何使用我们的网站。'
				},
				{
					type: '定向型',
					purpose: '使我们能够确保广告更贴合您的需求。'
				}]
			}
		},
		'section4-1': {
			title: '必需型 Cookie',
			table: {
				column: {
					title1: 'Cookie 名称',
					title2: '描述',
					title3: '有效期',
					title4: '域名',
					title5: '第一方或第三方 Cookie'
				},
				data: [
					{
						name: 'fs_merchant',
						description: '用于 S3 文件上传验证，允许用户在授权情况下上传文件',
						duration: '24 小时',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第一方'
					}
				]
			}
		},
		section4: {
			title: '功能型 Cookie',
			table: {
				column: {
					title1: 'Cookie 名称',
					title2: '描述',
					title3: '有效期',
					title4: '域名',
					title5: '第一方或第三方 Cookie'
				},
				data: [
					{
						name: 'vuepack',
						description: '用于记录用户多语言设置信息',
						duration: 'Session临时',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第一方'
					},
					{
						name: 'Site',
						description: '记录用户当前访问的站点信息',
						duration: 'Session临时',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第一方'
					}, {
						name: '_SIGNUP',
						description: '记录用户注册时选择的 location 信息',
						duration: 'Session临时',
						domain: ['.business.pingpongx.com'],
						firstOrThirdParty: '第一方'
					}, {
						name: '_gid',
						description: '官网地址来源记录',
						duration: '长期',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第一方'
					}, {
						name: 'Optanon Consent',
						description: '存储用户对网站 Cookie使用的同意选择和偏好设置',
						duration: '长期',
						domain: ['vn.pingpongx.com',
							'bd.pingpongx.com',
							'id.pingpongx.com',
							'th.pingpongx.com',
							'kr.pingpongx.com',
							'international.pingpongx.com'],
						firstOrThirdParty: '第三方'
					}
				]
			}
		},
		section5: {
			title: '分析型 Cookies',
			table: {
				column: {
					title1: 'Cookie 名称',
					title2: '描述',
					title3: '有效期',
					title4: '域名',
					title5: '第一方或第三方 Cookie'
				},
				data: [
					// {
					// 	name: 'acw_tc',
					// 	description: '大数据埋点，收集用户设备信息，用于记录用户行为数据',
					// 	duration: '30 分钟',
					// 	domain: ['.logbury.pingpongx.com'],
					// 	firstOrThirdParty: '第一方'
					// },
					{
						name: '_ga',
						description: 'Facebook 埋点统计',
						duration: '长期',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第三方'
					},
					{
						name: '_gcl_au',
						description: 'Facebook 埋点统计',
						duration: '长期',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第三方'
					}, {
						name: 'ar_debug',
						description: 'Google 埋点统计',
						duration: '长期',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: '第三方'
					}, {
						name: '_bl_uid',
						description: '阿里云 ARMS，用于前端性能监控和故障排查（即将在后续版本中弃用）',
						duration: '长期',
						domain: ['.business.pingpongx.com'],
						firstOrThirdParty: '第三方'
					}, {
						name: '_fwb',
						description: 'NAVER Web Counter Service 流量统计（NAVER 为韩国最大互联网公司）',
						duration: '长期',
						domain: [`.business.pingpongx.com`],
						firstOrThirdParty: '第三方'
					}
					// {
					// 	name: 'acw_tc',
					// 	description: '公司内部埋点追踪',
					// 	duration: '长期',
					// 	domain: [`.pingpongx.com`],
					// 	firstOrThirdParty: '第三方'
					// }
				]
			}
		},
		section6: {
			title: '如何管理 Cookie？',
			desc: '使用我们的网站时，您完全可以控制 Cookie。您可以通过以下方式控制或限制我们及第三方合作伙伴对 Cookie 的使用：',
			list: [{
				title: '浏览器和设备设置:',
				desc: '通过浏览器和设备设置禁用 Cookie。您可以通过清除浏览器的浏览记录来删除设备上已存储的所有 Cookie，这将删除您访问过的所有站点的 Cookie。但请注意，禁用 Cookie 可能导致我们的部分服务功能无法正常运行。以下是常见浏览器的 Cookie 管理页面链接；如果您的浏览器未列出，请查阅其官方说明：',
				items: [
					{
						name: 'Google Chrome：',
						link: '<a href=https://support.google.com/chrome/answer/95647?hl=en target=_blank >https://support.google.com/chrome/answer/95647?hl=en</a>'
					},
					{
						name: 'Apple Safari：',
						link: '<a href=https://support.apple.com/en-gb/guide/safari/sfri11471/mac target=_blank >https://support.apple.com/en-gb/guide/safari/sfri11471/mac</a>'
					},
					{
						name: ' Mozilla Firefox：',
						link: '<a href=https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox target=_blank >https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox</a>'
					},
					{
						name: 'Microsoft Edge：',
						link: '<a href=https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies target=_blank >https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a>'
					}
				]
			}, {
				title: '欧盟和英国用户:  ',
				desc: '在我们的站点设置非必需 Cookie 之前，我们会通过 “隐私偏好中心” 征求您的同意。如果您不希望为所有 Cookie 提供同意，应点击 [“拒绝所有”]；如果您希望为部分而非全部 Cookie 提供同意，应点击 [“确认我的选择”]；如果您希望接受所有 Cookie，应点击 [“允许所有”]。'
			}],
			desc1: '有关您权利的更多信息，请参阅我们的 <a href=https://www.pingpongx.com/zh/privacyPolicy?cb=true  target=_blank>隐私政策</a>。 '
		},
		section7: {
			title: '变更与修订',
			desc: '我们可能会不时更新本 Cookie 政策。更新后的版本将通过上方的 “最新更新” 日期标明，且一经发布即生效。如果我们对本 Cookie 政策进行重大变更，可能会通过显著位置发布变更通知或直接向您发送通知。我们建议您定期查看本 Cookie 政策，以了解我们如何使用 Cookie。 '
		},
		section8: {
			title: '联系我们',
			desc: '非欧洲经济区（EEA）和英国用户：可通过电子邮件  <a href="mailto:service@pingpongx.com">service@pingpongx.com</a>与我们联系',
			desc1: '欧洲经济区用户：可通过电子邮件 <a href="mailto:dpo-uk@pingpongx-uk.com">dpo@pingpongx-eu.com</a>或邮寄方式联系我们的数据保护官（DPO）：',
			european: [
				'PingPong Europe SA', 'Data Protection Department', 'Rue du Laboratoire 9 ', 'L-1911 Luxembourg'
			],
			desc2: '英国用户：可通过电子邮件 <a href="mailto:dpo-uk@pingpongx-uk.com">dpo-uk@pingpongx-uk.com</a>或邮寄方式联系我们的数据保护官（DPO）：',

			uk: [
				'PingPong Payments (UK) Limited', 'Data Protection Department', '78 Cannon Street, London, England, EC4N 6HL', 'United Kingdom'
			]

		}

	}
}
export default zh
